import { apiGetReferalInfo } from "Root/api/apiProfile";
import toastService from "Root/profile/toastService";
import { setGlobalLoading, setReferalInfo, setUncoveredFriends, setPurchasePeople, setReferalStoreAction, setStoredReferrals, } from "../../actionCreators/makeActionCreator";
export const LoadReferalInfoThunk = (reload = true) => async (dispatch) => {
    try {
        if (reload) {
            dispatch(setGlobalLoading(true));
        }
        const result = await apiGetReferalInfo();
        dispatch(setReferalInfo(result));
        if (reload) {
            dispatch(setGlobalLoading(false));
            if (result.unconverted_friends.length > 0) {
                dispatch(setUncoveredFriends(result.unconverted_friends));
                // @ts-ignore
                dispatch(setPurchasePeople(result.purchase_people));
                // @ts-ignore
                dispatch(setStoredReferrals(result.stored));
            }
            dispatch(setReferalStoreAction(false));
        }
        return result;
    }
    catch (error) {
        toastService.errorMessage("Something went wrong");
    }
    return null;
};
export default LoadReferalInfoThunk;
